// extracted by mini-css-extract-plugin
export default {"previewImg":"UpdateContact_previewImg__7tRYB","closeButton":"UpdateContact_closeButton__oJRo7","rounded":"UpdateContact_rounded__0yNo4"};